(function () {
  var KEY = 'engowishlist_v1';
  function safeParse(v) { try { return JSON.parse(v || '[]') } catch (e) { return [] } }
  function get() {
    var raw = safeParse(localStorage.getItem(KEY));
    // Filter out nulls or bad data immediately
    return raw.filter(function (x) { return x && x.handle; });
  }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) { } }
  function emit() { try { document.dispatchEvent(new CustomEvent('engowishlist.changed', { detail: get() })); } catch (e) { } }

  function add(product) {
    var list = get();
    console.log('EngoWishlist: Adding', product);
    if (list.find(function (x) { return x.handle === product.handle })) return list;
    list.push(product);
    save(list);
    emit();
    return list;
  }

  function remove(handle) {
    var list = get().filter(function (x) { return x.handle !== handle });
    save(list);
    emit();
    return list;
  }

  function toggle(product) {
    var list = get();
    var exists = list.find(function (x) { return x.handle === product.handle });
    if (exists) {
      remove(product.handle);
    } else {
      add(product);
    }
  }

  function isInWishlist(handle) {
    return !!get().find(function (x) { return x.handle === handle });
  }

  function clearAll() { save([]); emit(); }
  function list() { return get(); }

  // Always overwrite to ensure we use the new logic
  window.engoWishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    isInWishlist: isInWishlist,
    clear: clearAll,
    list: list
  };

  // Initial emit to sync UI
  emit();
})();
